import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { ConstantService } from '../_services/constant.service';
import { ConfirmationService } from 'primeng/api';

@Directive({
  selector: '[appHighlight]',
  standalone: true,
  providers: [ConfirmationService],
})
export class HighlightDirective {
  @Input() searchedWords: string[] | undefined;
  @Input() text: string | undefined;
  @Input() classToApply: string | undefined;
  keywordList = [];
  
  static compiledRegex: RegExp | null = null;
  static lastKeywordCount: number = 0;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private constant: ConstantService,
    private confirmationService: ConfirmationService
  ) {
    this.constant.getKeywordList().subscribe((data) => {
      this.keywordList = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.text) {
      return;
    }

    if (!this.searchedWords?.length && !this.keywordList?.length) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
      return;
    }

    let formatedtext = this.getFormattedText();
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', formatedtext);

    if (formatedtext !== this.text) {
      this.el.nativeElement.addEventListener('mousemove', (event: any) => {
        this.highlightHoveredWord(event);
      });
    }
  }

  getFormattedText() {
    let formatedText: any = this.text;
    if (this.keywordList && this.keywordList.length) {
      if (!HighlightDirective.compiledRegex || HighlightDirective.lastKeywordCount !== this.keywordList.length) {
        const allKeywords = this.keywordList
          .filter((k: any) => k && k.keyword)
          .map((k: any) => k.keyword.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'))
          .sort((a: any, b: any) => b.length - a.length); // match longest first
          
        if (allKeywords.length > 0) {
          HighlightDirective.compiledRegex = new RegExp(`(${allKeywords.join('|')})`, 'gi');
        } else {
          HighlightDirective.compiledRegex = null;
        }
        HighlightDirective.lastKeywordCount = this.keywordList.length;
      }
      
      if (HighlightDirective.compiledRegex) {
        formatedText = formatedText.replace(HighlightDirective.compiledRegex, `<a type="button" class="highlighted-keyword">$1</a>`);
      }
    }
    if (this.searchedWords?.length && this.classToApply) {
      const validWords = this.searchedWords
        .filter(w => w)
        .map(w => w.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'));
        
      if (validWords.length > 0) {
        const re = new RegExp(`(${validWords.join('|')})`, 'gi');
        formatedText = formatedText.replace(
          re,
          `<span class="${this.classToApply}">$1</span>`
        );
      }
    }
    return formatedText;
  }

  highlightHoveredWord(event: MouseEvent) {
    const hoveredWord: any = this.getHoveredWord(event);
    let data = this.keywordList.filter((data: any) => {
      return hoveredWord
        ? data.keyword.toLowerCase() === hoveredWord.toLowerCase()
        : false;
    });
    data.length ? this.popupOpen(event, data[0]) : this.popupClose();
  }

  getHoveredWord(event: MouseEvent): string | null {
    const target = this.el.nativeElement as HTMLElement;
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    const words = Array.from(target.childNodes) as Array<HTMLElement>;
    for (const word of words) {
      if (word.nodeType === Node.TEXT_NODE) continue;
      const rect = word.getBoundingClientRect();
      if (
        rect.left <= mouseX &&
        rect.right >= mouseX &&
        rect.top <= mouseY &&
        rect.bottom >= mouseY
      ) {
        return word.textContent?.trim() || null;
      }
    }

    return null;
  }

  popupOpen(event: Event, data: any) {
    if (event.target) {
      this.confirmationService.confirm({
        target: event.target,
        header: data.keyword,
        message: data.description,
        acceptVisible: false,
        rejectVisible: false,
      });
    }
  }

  popupClose() {
    this.confirmationService.close();
  }
}
